import { SiteHeader, SiteFooter } from "@/components/demo/DemoShell";
import { Layers, Zap, ShieldCheck, ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1542903107-db6be5823cba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxtaW5pbWFsJTIwYWJzdHJhY3R8ZW58MHx8fHdoaXRlfDE3ODc2MTU2MDV8MA&ixlib=rb-4.1.0&q=85&w=1600";

const FEATURES = [
  {
    icon: Layers,
    title: "Sample Feature One",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna.",
  },
  {
    icon: Zap,
    title: "Sample Feature Two",
    body: "Vestibulum id ligula porta felis euismod semper. Nullam quis risus eget urna mollis.",
  },
  {
    icon: ShieldCheck,
    title: "Sample Feature Three",
    body: "Cras mattis consectetur purus sit amet fermentum. Donec ullamcorper nulla non metus.",
  },
];

export default function DemoLanding() {
  return (
    <div data-testid="demo-landing" className="min-h-screen bg-white text-slate-900">
      <SiteHeader />

      {/* Hero */}
      <section data-testid="landing-hero" className="mx-auto max-w-6xl px-5 pt-16 pb-12 sm:px-8 sm:pt-24">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <span
              data-testid="hero-eyebrow"
              className="inline-block rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-indigo-600"
            >
              Sample Landing
            </span>
            <h1
              data-testid="hero-heading"
              className="mt-5 text-4xl font-bold leading-[1.1] tracking-tight text-slate-900 sm:text-5xl"
            >
              A clean, neutral canvas for Pinlayr
            </h1>
            <p data-testid="hero-subhead" className="mt-5 max-w-md text-lg leading-relaxed text-slate-500">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              posuere erat a ante venenatis dapibus posuere velit aliquet.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <button
                data-testid="hero-cta"
                className="inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700"
              >
                Get started <ArrowRight className="h-4 w-4" />
              </button>
              <button
                data-testid="hero-secondary"
                className="text-sm font-semibold text-slate-600 transition-colors hover:text-slate-900"
              >
                Learn more
              </button>
            </div>
          </div>

          <div data-testid="hero-image-wrap" className="relative">
            <img
              data-testid="hero-image"
              src={HERO_IMG}
              alt="Sample minimal architecture"
              className="aspect-[4/3] w-full rounded-2xl object-cover shadow-xl ring-1 ring-slate-200"
            />
          </div>
        </div>
      </section>

      {/* Feature cards */}
      <section data-testid="landing-features" className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              data-testid={`feature-card-${i + 1}`}
              className="rounded-2xl border border-slate-200 bg-slate-50/60 p-7 transition-shadow hover:shadow-md"
            >
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-indigo-600/10 text-indigo-600">
                <f.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{f.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA band */}
      <section data-testid="landing-cta-band" className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <div className="flex flex-col items-center justify-between gap-6 rounded-3xl bg-slate-900 px-8 py-12 text-center sm:flex-row sm:text-left">
          <div>
            <h2 className="text-2xl font-bold text-white">Ready to leave a pin?</h2>
            <p className="mt-1 text-slate-300">Enter review mode and drop a comment anywhere on this page.</p>
          </div>
          <button
            data-testid="cta-band-button"
            className="shrink-0 rounded-lg bg-white px-6 py-3 text-sm font-semibold text-slate-900 transition-colors hover:bg-slate-100"
          >
            Sample Action
          </button>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
